var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFloatValve = function SvgFloatValve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m21.978 20.773-3.967-4.115L9 22V10l9.011 5.342 3.967-4.115L23 12.287 19.422 16 23 19.712z",
    clipRule: "evenodd"
  })));
};
export { SvgFloatValve as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M21.9778 20.7729L18.0114 16.6583L9 22L9 10L18.0114 15.3418L21.9779 11.227L23.0004 12.2877L19.4218 16L23.0003 19.7122L21.9778 20.7729Z' fill='%234A6067'/%3e %3c/svg%3e";